import { useEffect, useState } from "react";
import { confirmReservationFromLink } from "../api/confirm";
import { getQueryParam } from "../utils/url";
import { PageShell, PageHeading, PageText, StatusIcon, PrimaryButton } from "./shared";

export default function ConfirmPage() {
    const [status, setStatus] = useState<"loading" | "ok" | "error">("loading");
    const [msg, setMsg] = useState("Bezig met bevestigen...");

    useEffect(() => {
        (async () => {
            const token = getQueryParam("token");
            const companySlug = getQueryParam("company");
            const apiBase = getQueryParam("apiBase") || getQueryParam("api-base");

            if (!token) return fail("Deze link is niet compleet — probeer de link opnieuw vanuit je e-mail.");
            if (!companySlug) return fail("Deze link is niet compleet — probeer de link opnieuw vanuit je e-mail.");
            if (!apiBase) return fail("Deze link is niet compleet — probeer de link opnieuw vanuit je e-mail.");

            try {
                await confirmReservationFromLink(apiBase, companySlug, token);
                setStatus("ok");
                setMsg("Je afspraak is bevestigd. Je kunt dit scherm sluiten.");
            } catch (e: any) {
                fail(friendlyMessage(e));
            }
        })();

        function fail(message: string) {
            setStatus("error");
            setMsg(message);
        }
    }, []);

    return (
        <PageShell>
            <div style={{ textAlign: "center" }}>
                <StatusIcon kind={status} />
                <PageHeading>
                    {status === "loading" && "Bezig met bevestigen…"}
                    {status === "ok" && "Afspraak bevestigd"}
                    {status === "error" && "Dat lukte niet"}
                </PageHeading>
                <PageText dim>{msg}</PageText>

                {status === "ok" && (
                    <div style={{ marginTop: 20 }}>
                        <PrimaryButton onClick={() => window.close()}>Sluiten</PrimaryButton>
                    </div>
                )}
            </div>
        </PageShell>
    );
}

/** Vertaalt een technische/serverfout naar iets wat een klant begrijpt — een expired of
 * al-gebruikte bevestigingslink is verreweg het meest voorkomende geval. */
function friendlyMessage(e: any): string {
    if (e?.status === 410) {
        return "Deze bevestigingslink is verlopen. Neem contact op met het bedrijf om je afspraak alsnog te bevestigen.";
    }
    if (e?.status === 409) {
        return "Deze afspraak is al geannuleerd.";
    }
    if (e?.status === 404) {
        return "Deze link is niet geldig meer.";
    }
    return "Bevestigen is niet gelukt. Probeer het later opnieuw of neem contact op met het bedrijf.";
}
